import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spinner-border TumiSpinner",
  role: "status"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DynamicPage = _resolveComponent("DynamicPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.activeObject)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.activeObject)
      ? (_openBlock(), _createBlock(_component_DynamicPage, {
          key: 1,
          objet: _ctx.activeObject,
          validate: _ctx.error,
          onAction: _ctx.Save,
          repeatPlaceholder: true,
          name: 'Create new project'
        }, null, 8, ["objet", "validate", "onAction"]))
      : _createCommentVNode("", true)
  ], 64))
}